/* eslint-disable */
/**
 *  @module Rgpd
 *  @description
 *  Managing cookies via categories.
 *
 *  @element .rgpd-manage-link - open the manage popin
 *
 *  @callback onexec(cat) - fired if at least 1 category is enabled.
 *  @param cat - in checkbox val, is the id of the cookie ex 'stats'
 *  @var cookieName name of the rgpd cookie
 *
 */

 const Rgpd = onexec => {
    const cookieDuration = 30;
    const cookieName = 'rgpd';
    const root = document.documentElement || window;
    const clicktouch = ('ontouchstart' in root) ? 'touchstart' : 'click';
    const modal = document.getElementById('rgpd-modal');
    const btn_accept = modal.querySelector('.btn-accept');
    const btn_refuse = modal.querySelector('.btn-refuse');
    const manage = document.getElementById('rgpd-manage');

    // const manage_box = manage.querySelector('.box');
    const btn_save = manage.querySelector('.btn-save');
    const checkboxes = manage.querySelectorAll('input[type="checkbox"]');
    // const btn_close = manage.querySelector('.btn-close');
    const manage_button = document.querySelectorAll('.rgpd-manage-link');
    const manage_links = document.querySelectorAll('a[href="#rgpd-manage"]');
    let scrollTop;
    let cats = {};

    const cookie = {
        create(name, value, days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            document.cookie = `${name}=${value}${days ? `; expires=${date.toGMTString()}` : ''}; path=/`; 
        },
        read(name) {
            const nameEQ = `${name}=`;
            for(let item of document.cookie.split(';')){
                while (item.charAt(0) === ' ') item = item.substring(1, item.length);
                if (item.indexOf(nameEQ) === 0) return item.substring(nameEQ.length, item.length); 
            }
            return null;
        },
        erase(name) {
            var hostname = document.location.hostname;
            if (hostname.indexOf('www.') === 0) hostname = hostname.substring(4);
            //hostname = hostname.substr(hostname.indexOf('.') + 1); //if subdomains
            document.cookie = `${name}=; domain=.${hostname}; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=`;
            document.cookie = `${name}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/`;
        },
        eraseUnused() {
            for (let checkbox of checkboxes) {
                !checkbox.checked && checkbox.dataset.cookies.split(',').forEach(val => cookie.erase(val));
            }
        },
    };

    let consent = cookie.read(cookieName) ? true : false;

    // fire event onexec if cat == true
    const execute = () => {
        for (let key in cats) {
            (cats[key] && typeof onexec === 'function') && onexec(key)

            if (key == ['stats']) { window.stats = true }
        };
    }

    // set cookie obj status
    const status = () => checkboxes.forEach(item => cats[item.value] = item.checked ? true : false)

    const set_consent = () => {
        consent = true;
        modal.classList.remove('active');
        cookie.create(cookieName, JSON.stringify(cats), cookieDuration);

        if (true) {}
    }

    const accept = () => {
        checkboxes.forEach(checkbox => checkbox.checked = true)
        status();
        execute();
        set_consent();
    }

    const denie = () => {
        checkboxes.forEach(checkbox => checkbox.checked = false)
        status();
        set_consent();
    }

    const save = () => {
        status();
        !consent && execute();
        set_consent();
        // cookie.eraseUnused();
    }

    if (consent !== true) {
        modal.classList.add('active');
    }
    // init or load cookie obj
    if (consent === true) cats = JSON.parse(localStorage.getItem(cookieName));

    // init or load cookie obj
    if (consent === true) cats = JSON.parse(cookie.read(cookieName));

    else checkboxes.forEach(checkbox => cats[checkbox.value] = true);
    
    // init checkboxes
    for(let key in cats){
        for(let checkbox of checkboxes){
            if(checkbox.value == key) checkbox.checked = cats[key];
        }
    }

    btn_accept.onclick = () => accept();

    btn_refuse.onclick = () => denie();

    if (consent === true) {
        execute();
    } else {
        modal.removeAttribute('aria-hidden');
        btn_refuse.focus();
    }

    manage_links.forEach(link => {
        link.onclick = e => {
            e.stopPropagation();
            e.preventDefault();
        };
    });
    manage_button.forEach(link => {
        link.onclick = e => {
            e.stopPropagation();
            e.preventDefault();
        };
    });

    btn_save.onclick = () => {
        save();
    };

    // btn_close.onclick = e => close(e);
};

export default Rgpd;
